import { ReactComponent as IconUser } from 'nes.icons/icons/user.svg';
import React, { CSSProperties } from 'react';

interface IProps {
  onClick?: () => any;
  hidden?: boolean;
}

const HeaderScoreScreenButton: React.FC<IProps> = ({ hidden, onClick }) => {
  return (
    <button
      className={'nes-btn is-success'}
      onClick={onClick}
      style={{ ...buttonStyle, visibility: hidden ? 'hidden' : 'visible' }}
    >
      <IconUser className={'nes-icon is-small fill-white'} style={{ margin: '0 2px 2px 0' }} />
    </button>
  );
};

const buttonStyle: CSSProperties = {
  height: '45px',
  width: '45px',
};

export default HeaderScoreScreenButton;
